// @ts-ignore
// @ts-nocheck

import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { create } from "zustand";
import * as Sentry from "@sentry/react";

import { getCurrentAdminQueryOptions } from "@/config/queries/query-options";
import { getCurrentEmployeeQueryOptions } from "@/config/queries/emp-query-options";
import { getCurrentSuperAdminQueryOptions } from "@/config/queries/superadmin-query-options";
import { getCurrentTeamLeaderQueryOptions } from "@/config/queries/teamleader/tl-query-options";
import { setLogActor, logEvent } from "@/lib/client-log";
import { getSessionToken, startSession } from "@/lib/session";

interface AuthContext {
  isAuthenticated: boolean;
  setisAuth: (isAuth: boolean) => void;
  setUser: (userCookie: string, userRole: string) => void;
  removeUser: () => void;
  user: string;
}

export const useAuthContext = create<AuthContext>()((set) => ({
  isAuthenticated: Cookies.get("key") ? true : false,
  setisAuth: (isAuth) =>
    set(() => ({
      isAuthenticated: isAuth,
    })),
  setUser: (userCookie, userRole) =>
    set((state) => {
      startSession(userCookie, userRole, 14);

      return {
        ...state,
      };
    }),
  removeUser: () =>
    set(() => ({
      user: "",
    })),
  user: (Cookies.get("key") as string) || "",
}));

export const useAuth = () => {
  const key = getSessionToken() as string;
  const userRole = localStorage.getItem("userRole") as
    | "admin"
    | "employee"
    | "superadmin";

  // const queryOptions =
  //   userRole === "employee"
  //     ? getCurrentEmployeeQueryOptions
  //     : getCurrentAdminQueryOptions;

  const queryOptions =
    userRole === "employee"
      ? getCurrentEmployeeQueryOptions
      : userRole === "admin"
      ? getCurrentAdminQueryOptions
      : userRole === "teamleader"
      ? getCurrentTeamLeaderQueryOptions
      : getCurrentSuperAdminQueryOptions;
  // const queryOptions =
  //   userRole === "admin"
  //     ? getCurrentAdminQueryOptions
  //     : getCurrentEmployeeQueryOptions;

  const { data, isPending, isError, error } = useQuery(queryOptions(key));

  useEffect(() => {
    const u =
      data?.foundAdmin || data?.foundEmployee || data?.foundSuperAdmin || data?.foundTeamLeader;
    if (u && key) {
      Sentry.setUser({
        id: u._id ? String(u._id) : undefined,
        email: u.email,
        username: u.name,
        role: userRole,
      });
      // Same identity onto every Axiom event. "Which account is this session on?"
      // is the question that took hours to answer during the empty-portal incident.
      setLogActor({
        actorType: userRole,
        actorId: u._id ? String(u._id) : undefined,
        actorEmail: u.email,
        actorName: u.name,
      });
      logEvent({ kind: "session_identified", accountEmail: u.email });
    } else if (!key) {
      Sentry.setUser(null);
      setLogActor({});
    }
  }, [data, key, userRole]);

  return {
    data: {
      success: data?.success,
      error: data?.error,
      user: {
        ...(userRole === "admin"
          ? data?.foundAdmin
          : userRole === "employee"
          ? data?.foundEmployee
          : userRole === "teamleader"
          ? data?.foundTeamLeader
          : data?.foundSuperAdmin),
      },
    },
    isPending,
    isError,
    error,
  };
};
